import { ProjectTeamMemberAssignmentViewModel } from 'src/app/shared/models/autogenerated';

export class TeamMember extends ProjectTeamMemberAssignmentViewModel {
  displayName?: string;
  userPrincipalName?: string;
  constructor(data: any) {
    super(data);
  }
}
